import React, { Component as C } from "react"
import classNames from "classnames"

import styles from "./styles.less"

class TableToolbar extends C {
  render() {
    return (
      <div className={classNames(styles.container, this.props.className)}>
        <div className={styles.tableTollbar}>
          {this.props.children ? (
            <div className={styles.withControls}>{this.props.children}</div>
          ) : null}
        </div>
      </div>
    )
  }
}

export default TableToolbar
